import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API}/api/promotions`;

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return { headers: { Authorization: `Bearer ${token}` } };
};

export const promotionService = {
  // Get all promotions
  getAllPromotions: async () => {
    const response = await axios.get(API_URL, getAuthHeader());
    return response.data;
  },

  // Get promotion by code
  getPromotionByCode: async (code) => {
    const response = await axios.get(`${API_URL}/${code}`, getAuthHeader());
    return response.data;
  },

  // Convenience: validate / apply a promotion (returns promotion object or throws)
  applyPromotion: async (code) => {
    const response = await axios.get(`${API_URL}/${code}`, getAuthHeader());
    return response.data;
  },

  // Create promotion
  createPromotion: async (promotionData) => {
    const response = await axios.post(API_URL, promotionData, getAuthHeader());
    return response.data;
  },

  // Update promotion
  updatePromotion: async (id, promotionData) => {
    const response = await axios.put(`${API_URL}/${id}`, promotionData, getAuthHeader());
    return response.data;
  },

  // Delete promotion
  deletePromotion: async (id) => {
    const response = await axios.delete(`${API_URL}/${id}`, getAuthHeader());
    return response.data;
  },

  // Activate promotion
  activatePromotion: async (id) => {
    const response = await axios.patch(`${API_URL}/${id}/activate`, {}, getAuthHeader());
    return response.data;
  },

  // Deactivate promotion
  deactivatePromotion: async (id) => {
    const response = await axios.patch(`${API_URL}/${id}/deactivate`, {}, getAuthHeader());
    return response.data;
  },

  // Bulk activate
  bulkActivate: async (ids) => {
    const response = await axios.post(`${API_URL}/bulk/activate`, { ids }, getAuthHeader());
    return response.data;
  },

  // Bulk deactivate
  bulkDeactivate: async (ids) => {
    const response = await axios.post(`${API_URL}/bulk/deactivate`, { ids }, getAuthHeader());
    return response.data;
  },

  // Bulk delete
  bulkDelete: async (ids) => {
    const response = await axios.post(`${API_URL}/bulk/delete`, { ids }, getAuthHeader());
    return response.data;
  }
};